import Device from '@/models/Device'
// import Api from '@/api'

export default {
  namespaced: true,
  state: {
    deviceDetails: null,
  },

  mutations: {
    setDeviceDetails(state, device) {
      if (device instanceof Device) {
        state.deviceDetails = device
      } else {
        state.deviceDetails = new Device(device)
      }
    },

    clearDeviceDetails(state) {
      state.deviceDetails = null
    },
  },

  actions: {
    async storeDeviceDetails({ commit }, fcmToken) {
      const { data } = await new Device({
        device_token: fcmToken,
        device_id: 'test_id',
      }).save()

      // const { data } = await Api.post(`devices`, fcmToken)

      // console.log(data)
      commit('setDeviceDetails', data)
    },
  },
}
